import _createForOfIteratorHelper from "@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Editor, Range, Path, Node, Point, Text } from 'slate';

// modifyed function from slate
// The goal of the modification: focus the selection to the end of the last inserted node

export var insertNodes = function insertNodes(editor, nodes) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Editor.withoutNormalizing(editor, function () {
    // eslint-disable-next-line no-unused-vars
    var selection = editor.selection;
    var _options$hanging = options.hanging,
      hanging = _options$hanging === void 0 ? false : _options$hanging,
      _options$voids = options.voids,
      voids = _options$voids === void 0 ? false : _options$voids;
    var at = options.at,
      match = options.match,
      select = options.select;
    if (Node.isNode(nodes)) {
      nodes = [nodes];
    }
    if (nodes.length === 0) {
      return;
    }
    var _nodes = nodes,
      _nodes2 = _slicedToArray(_nodes, 1),
      node = _nodes2[0];
    // By default, use the selection as the target location. But if there is
    // no selection, insert at the end of the document since that is such a
    // common use case when inserting from a non-selected state.
    if (!at) {
      if (editor.selection) {
        at = editor.selection;
      } else if (editor.children.length > 0) {
        at = Editor.end(editor, []);
      } else {
        at = [0];
      }
      select = true;
    }
    if (select == null) {
      select = false;
    }
    if (Range.isRange(at)) {
      if (!hanging) {
        at = Editor.unhangRange(editor, at);
      }
      if (Range.isCollapsed(at)) {
        at = at.anchor;
      } else {
        var _Range$edges = Range.edges(at),
          _Range$edges2 = _slicedToArray(_Range$edges, 2),
          end = _Range$edges2[1];
        var pointRef = Editor.pointRef(editor, end);
        Editor.delete(editor, {
          at: at
        });
        at = pointRef.unref();
      }
    }
    if (Point.isPoint(at)) {
      if (match == null) {
        if (Text.isText(node)) {
          match = 'text';
        } else if (editor.isInline(node)) {
          match = ['inline', 'text'];
        } else {
          match = 'block';
        }
      }
      var atMatch = Editor.match(editor, at.path, match);
      if (atMatch) {
        var _atMatch = _slicedToArray(atMatch, 2),
          matchPath = _atMatch[1];
        var pathRef = Editor.pathRef(editor, matchPath);
        var isAtEnd = Editor.isEnd(editor, at, matchPath);
        Editor.splitNodes(editor, {
          at: at,
          match: match
        });
        var _path = pathRef.unref();
        at = isAtEnd ? Path.next(_path) : _path;
      } else {
        return;
      }
    }
    var parentPath = Path.parent(at);
    var index = at[at.length - 1];
    if (!voids && Editor.match(editor, parentPath, 'void')) {
      return;
    }
    var path = [];
    var _iterator = _createForOfIteratorHelper(nodes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _node = _step.value;
        path = parentPath.concat(index);
        index++;
        at = path;
        editor.apply({
          type: 'insert_node',
          path: path,
          node: _node
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (select) {
      var point = Editor.end(editor, at);
      if (point) {
        Editor.select(editor, point);
      }
    }
  });
};